import {
  buildsServiceApi,
  LegacyApi,
  ModernApi,
  oldBaseApi,
} from "../../api";

export async function getProjectsLegacy(
  params: LegacyApi.GetProjectsRequest,
): Promise<LegacyApi.GetProjectsResponse> {
  const res = await oldBaseApi.get<LegacyApi.GetProjectsResponse>(
    "api/projects/",
    {
      params,
    },
  );
  return res.data;
}

export async function getProjects(
  params: ModernApi.GetProjectsRequest,
): Promise<ModernApi.GetProjectsResponse> {
  const res = await buildsServiceApi.get<ModernApi.GetProjectsResponse>(
    "/projects",
    {
      params,
      headers: {
        Accept: "*/*",
      },
    },
  );
  return res.data;
}
